module.exports = __webpack_public_path__ + "static/media/delete2.e0beeefc.svg";